import {
  QualificationsActionTypes,
  SET_ASSESSMENT,
  SET_ERROR,
  SET_QUALIFICATIONS,
  SET_QUALIFICATION,
  SET_ASSESSMENT_VERSIONS,
  SET_ASSESSMENT_VERSION,
} from './types';
import { Qualification, QualificationsState } from '../../types/Qualifications';
import { RESET_GLOBAL_STATE, GlobalActionTypes } from '../types';
import { unknown } from '../actions';
import { Assessment } from '../../types/Syllabuses';

const initialState: QualificationsState = {
  qualificationData: undefined,
  isLoading: true,
  hasError: false,
  qualification: undefined,
  assessment: undefined,
  assessmentVersions: undefined,
};

export default (
  state = initialState,
  action: QualificationsActionTypes | GlobalActionTypes = unknown(),
): QualificationsState => {
  switch (action.type) {
    case SET_ASSESSMENT: {
      const {
        payload: { selectedAssessment },
      } = action;
      return {
        ...state,
        assessment: selectedAssessment,
      };
    }

    case SET_QUALIFICATION: {
      const {
        payload: { selectedQualification },
      } = action;

      return {
        ...state,
        qualification: selectedQualification,
      };
    }
    case SET_QUALIFICATIONS: {
      const {
        payload: { qualificationData },
      } = action;

      const qualificationsWithSortedAssessments = qualificationData.map(
        (qualification: Qualification): Qualification => ({
          ...qualification,
          assessments: qualification.assessments
            .slice()
            .sort((a: Assessment, b: Assessment) => a.code.localeCompare(b.code)),
        }),
      );

      return {
        ...state,
        qualificationData: qualificationsWithSortedAssessments,
        isLoading: false,
        hasError: false,
      };
    }
    case SET_ASSESSMENT_VERSIONS: {
      const {
        payload: { assessmentVersions },
      } = action;

      return {
        ...state,
        assessmentVersions,
      };
    }
    case SET_ASSESSMENT_VERSION: {
      const {
        payload: { version, availableIn },
      } = action;

      const updatedAssessment = {
        ...state.assessment,
        version,
        availableIn,
      } as Assessment;

      return {
        ...state,
        assessment: updatedAssessment,
      };
    }
    case SET_ERROR: {
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };
    }
    case RESET_GLOBAL_STATE: {
      return initialState;
    }

    default:
      return state;
  }
};
